module.exports = __webpack_public_path__ + "img/login_main_bg1.683be788.jpeg";